export default "__VITE_ASSET__a6a307d0__"